var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-list-container",attrs:{"id":"data-list-list-view"}},[_c('vx-card',{attrs:{"title":"Overview"}},[_c('p',[_vm._v("New Announcements")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }